import { render } from "./PageNavItem.vue?vue&type=template&id=6ee2cb00&scoped=true"
import script from "./PageNavItem.vue?vue&type=script&lang=js"
export * from "./PageNavItem.vue?vue&type=script&lang=js"

import "./PageNavItem.vue?vue&type=style&index=0&id=6ee2cb00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee2cb00"]])

export default __exports__